import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=5ad511d3&scoped=true&"
import script from "./Battle.vue?vue&type=script&lang=js&"
export * from "./Battle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad511d3",
  null
  
)

export default component.exports